import moment from 'moment'
import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/Crm/subjects'

export default {
  namespaced: true,
  state: {
    loading: false,
    subjects: {
      data: [],
      grandTotals: [],
      chartGrandTotals: {
        series: [],
        labels: [],
      },
    },
    /* Filter Params */
    subjectParams: {
      sdate: `${moment().format('YYYY-MM')}-01`,
      edate: moment().format('YYYY-MM-DD'),
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    subjects(state) {
      return state.subjects
    },
    /* Filter Params */
    subjectParams(state) {
      return state.subjectParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_SUBJECTS(state, data) {
      state.subjects = data
    },
    /* RESET MUTATIONS */
    RESET_SUBJECTS(state) {
      state.subjects = {
        data: [],
        grandTotals: [],
        chartGrandTotals: {
          series: [],
          labels: [],
        },
      }
    },
  },
  actions: {
    getSubjects({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_SUBJECTS')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_SUBJECTS', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
